import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  title_vi: '',
  title_en: '',
  title_jp: '',
  subtitle_vi: '',
  subtitle_en: '',
  subtitle_jp: '',
  description_vi: '',
  description_en: '',
  description_jp: '',
  image: '',
  search: '',
  status: 0,
};
export const serviceItemSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {
    setItem: (state, action) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
    setDefaultValue: (_, action) => {
      if (!action?.payload?.id) return initialState;
      return { ...action.payload };
    },
    resetData: () => {
      return initialState;
    },
  },
});
export const { setItem, setDefaultValue, resetData } = serviceItemSlice.actions;

export default serviceItemSlice.reducer;
